import { render, staticRenderFns } from "./SectionNav.vue?vue&type=template&id=6e7bddc2&scoped=true"
import script from "./SectionNav.vue?vue&type=script&lang=ts"
export * from "./SectionNav.vue?vue&type=script&lang=ts"
import style0 from "./SectionNav.vue?vue&type=style&index=0&id=6e7bddc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7bddc2",
  null
  
)

export default component.exports